/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */

import moment from 'moment';

import { colors } from '../../../../../../theme';
import { EFormatData } from '../../../../types/widgetTypes';
import { EWidgetCostsChart, IWidgetConfiguration } from '../types/widgetCostsType';
import { IWidgetCostsReducer } from '../widgetCostsReducer';

export const widgetCostsInitialState: IWidgetCostsReducer = {
    charts: {},
    currentDateTo: '',
    error: '',
    isLoading: true,
};

export const widgetCostsConfiguration: IWidgetConfiguration = {
    carousel: {
        responsive: {
            superLargeDesktop: {
                breakpoint: { max: 4000, min: 3000 },
                items: 1,
            },
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 1,
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 1,
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1,
            },
        },
    },
    chart: {
        colors: {
            [EWidgetCostsChart.ONE_TIME_CHARGES]: colors.pageDashboardChartOneTimeCharges,
            [EWidgetCostsChart.OTHER_RECURRING_CHARGES]: colors.pageDashboardChartOtherRecurringCharges,
            [EWidgetCostsChart.RECURRING_CHARGES_FOR_RATE_PLAN]: colors.pageDashboardChartRecurringChargesForRatePlan,
            [EWidgetCostsChart.TRAFFIC_CHARGES_AT_HOME_MACRO_REGION_AND_NOT_IN_HOME_REGION]:
            colors.pageDashboardChartTrafficChargesAtHomeMacroRegionAndNotInHomeRegion,
            [EWidgetCostsChart.TRAFFIC_CHARGES_AT_HOME_REGION]: colors.pageDashboardChartTrafficChargesAtHomeRegion,
            [EWidgetCostsChart.TRAFFIC_CHARGES_AT_OUT_HOME_MACRO_REGION]:
            colors.pageDashboardChartTrafficChargesAtOutHomeMacroRegion,
            [EWidgetCostsChart.TRAFFIC_CHARGES_AT_ROAMING]: colors.pageDashboardChartTrafficChargesAtRoaming,
        },
        innerRadius: 0.75,
        legendSize: 4,
        padding: [0, 0, 0, 0],
        radius: 1,
        size: 226,
        strokeColor: colors.pageDashboardChartStroke,
        yearLimit: 3,
    },
    chartEmpty: {
        data: [
            {
                color: colors.pageDashboardChartEmptyColor,
                item: '',
                value: 25,
            },
            {
                color: colors.pageDashboardChartEmptyColor,
                item: '',
                value: 15,
            },
            {
                color: colors.pageDashboardChartEmptyColor,
                item: '',
                value: 20,
            },
            {
                color: colors.pageDashboardChartEmptyColor,
                item: '',
                value: 40,
            },
        ],
    },
    dateFormat: EFormatData.FullData,
    dateFormatRedirect: EFormatData.FullDateWithFullTime,
    initDataFrom: moment().startOf('month').format(EFormatData.FullData),
    initDateTo: moment().endOf('month').format(EFormatData.FullData),
    skeleton: {
        multiple: 0.76,
    },
};
